import { render } from "./BlockPage.vue?vue&type=template&id=8fc8a2f2&scoped=true"
import script from "./BlockPage.vue?vue&type=script&lang=js"
export * from "./BlockPage.vue?vue&type=script&lang=js"

import "./BlockPage.vue?vue&type=style&index=0&id=8fc8a2f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fc8a2f2"]])

export default __exports__